import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoutUser from '../../use-cases/logoutUser';

const LogoutView = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logoutUser();
    navigate('/login', { replace: true });
  }, []);

  return <></>;
};

export default LogoutView;
